import { ShopHeroGlow } from "./ShopHeroGlow";
import { ShopHeroGrid } from "./ShopHeroGrid";
import { ShopHeroMotes } from "./ShopHeroMotes";
import { ShopHeroVideo } from "./ShopHeroVideo";
import { useHeroParallax } from "./useHeroParallax";
import { useHeroPointerGlow } from "./useHeroPointerGlow";

export interface ShopHeroBackdropProps {
  motionOk: boolean;
}

/**
 * Todo lo que va DEBAJO del velo: vídeo, retícula, resplandor y elementos
 * flotantes, montados sobre una única capa que hace el parallax.
 *
 * ── Una sola capa se mueve, no cuatro ────────────────────────────────
 * Las cuatro piezas viven dentro del mismo contenedor y es ese contenedor
 * el que recibe el `transform`. Animar cada una por separado significaría
 * cuatro capas de composición y cuatro escrituras por fotograma para
 * conseguir exactamente el mismo efecto.
 *
 * ── El fondo sobresale por arriba y por abajo ────────────────────────
 * `-inset-y-[14%]` — ese 14 % es `OVERSCAN` en `useHeroParallax`, y es de
 * donde el parallax saca el recorrido. Si aquí se cambia, allí también:
 * el fondo se bajaría más de lo que sobra y aparecería una franja vacía
 * arriba.
 *
 * ── En escritorio el vídeo se aparta del texto ───────────────────────
 * Ese es el "sin que afecten los mismos textos el bg" de Anahi, resuelto
 * en la geometría antes que con opacidad: a partir de `lg` el vídeo
 * empieza al 32 % del ancho y su borde izquierdo entra con una máscara,
 * así que la columna donde está el titular es tinta limpia y la forma del
 * vídeo se queda entera a la derecha. En pantallas estrechas no hay dos
 * columnas que repartir: el vídeo ocupa todo y de la legibilidad se
 * encarga el velo, que allí es más denso.
 *
 * ── `pointer-events-none` ────────────────────────────────────────────
 * Sin esto, el vídeo se come los clics de media portada y el menú
 * contextual del navegador ofrece "guardar vídeo como…" sobre el titular.
 */
export function ShopHeroBackdrop({ motionOk }: ShopHeroBackdropProps) {
  const parallaxRef = useHeroParallax(motionOk);
  const glowRef = useHeroPointerGlow(motionOk);

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 overflow-hidden"
    >
      <div ref={parallaxRef} className="absolute inset-x-0 -inset-y-[14%]">
        <div className="absolute inset-0 lg:left-[32%] lg:[mask-image:linear-gradient(to_right,transparent_0%,black_26%)]">
          <ShopHeroVideo motionOk={motionOk} />
        </div>

        <ShopHeroGrid />
        <ShopHeroGlow glowRef={glowRef} />
        <ShopHeroMotes motionOk={motionOk} />
      </div>
    </div>
  );
}
